import React, { useState } from "react";
import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import {useDispatch} from "react-redux";
import {stopContractRequest} from "../redux/actions/contractActions";
import {useNavigate} from "react-router-dom";

function StopContractForm({ contract, setContractToStop }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Monat 0-basiert, daher +1
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const [stopDate, setStopDate] = useState(getCurrentDate());
    const [comment, setComment] = useState("");

    const handleDateChange = (event) => {
        setStopDate(event.target.value);
    };

    const handleCommentChange = (event) => {
        setComment(event.target.value);
    };

    const handleSubmit = (event) => {
        console.log("Selected stop date:", stopDate);
        console.log("Comment:", comment);
        dispatch(stopContractRequest({contractID: contract.ID, stopDate, comment}));
        navigate("/mdb/institute/overview");
    };

    return (
        <div className="container my-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <h1 className="mb-3">Vertrag beenden</h1>
                    <p>Bitte wählen Sie das Enddatum des Vertrags aus und fügen Sie einen Kommentar hinzu.</p>

                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label for="stopDate">Enddatum</Label>
                            <Input
                                type="date"
                                id="stopDate"
                                value={stopDate}
                                onChange={handleDateChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="comment">Kommentar (optional)</Label>
                            <Input
                                type="textarea"
                                id="comment"
                                value={comment}
                                onChange={handleCommentChange}
                                placeholder="Fügen Sie hier einen Kommentar hinzu..."
                            />
                        </FormGroup>
                        <div className="d-flex justify-content-between">
                            <Button type="cancel" color="secondary" onClick={() => setContractToStop(null)}
                                    className="ml-2">Abbrechen</Button>
                            <Button type="submit" color="primary">Vertrag beenden</Button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
}

export default StopContractForm;
